import { useRealtimeDelivery } from "@hooks/useRealtimeDelivery";
import React from "react";
export var AppDeliveryLayout = function AppDeliveryLayout(_ref) {
  var children = _ref.children;
  useRealtimeDelivery();
  return React.createElement(React.Fragment, null, children);
};